import { type FC, useState } from 'react';
import { Input } from '@/components/ui/input';
import { useTranslation } from '@/hooks/useTranslation';

const TOOL_ID_PATTERN = /^[A-Za-z0-9.-]+$/;

interface MLToolManualInputProps {
  value: string | null;
  onChange: (toolId: string) => void;
  disabled: boolean;
}

export const MLToolManualInput: FC<MLToolManualInputProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();
  const [raw, setRaw] = useState(value ?? '');
  const [touched, setTouched] = useState(false);

  const trimmed = raw.trim();
  const isValid = trimmed.length > 0 && TOOL_ID_PATTERN.test(trimmed);
  const showError = touched && trimmed.length > 0 && !isValid;

  function handleChange(next: string) {
    setRaw(next);
    const t2 = next.trim();
    if (t2.length > 0 && TOOL_ID_PATTERN.test(t2)) {
      onChange(t2);
    }
  }

  return (
    <div className="flex flex-col gap-1.5">
      <Input
        value={raw}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={() => setTouched(true)}
        disabled={disabled}
        placeholder={t('mlRul.context.step3PlaceholderManual')}
        aria-invalid={showError}
        data-testid="tool-manual-input"
      />
      {showError ? (
        <p className="text-xs text-destructive">{t('mlRul.context.step3ManualHelper')}</p>
      ) : (
        <p className="text-xs text-muted-foreground">{t('mlRul.context.step3ManualHelper')}</p>
      )}
      {isValid && (
        <p className="font-mono text-xs text-muted-foreground">{trimmed}</p>
      )}
    </div>
  );
};
